import {Component, Inject, OnInit} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { user } from '../../../models/user';
import { empresa } from '../../../models/empresa';
import {proyecto} from '../../../models/proyecto';
import {UserService} from '../../../services/user.service';
import {Localiser} from "../../../services/localiser";

@Component({
  selector: 'app-change-project',
  templateUrl: './change-project.component.html',
  styleUrls: ['./change-project.component.css']
})
export class ChangeProjectComponent implements OnInit {

  message: string;

  constructor(public dialogRef: MatDialogRef<ChangeProjectComponent>, @Inject(MAT_DIALOG_DATA) public data: {usuario: user, empresa: empresa},
              private userService: UserService, public localiser: Localiser) {
  }

  ngOnInit() {
  }

  onCancelClick(): void {
    this.dialogRef.close();
  }

  change(idProyecto, check) {
    this.userService.changeProyecto(this.data.usuario.idUsuario, idProyecto, check);
  }

  containsProyecto(proyecto: proyecto) {
    for (let proyectoU of this.data.usuario.proyectos) {
      if (proyectoU.idProyecto == proyecto.idProyecto) {
        return true;
      }
    }
    return false;
  }


}
